import { FC } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { SourceTableProps } from './ReportDialog.props';
import { bodyCellSx, reportDialogColors as colors, headerCellSx } from './ReportDialog.styles';
import { formatDate, formatPrice } from './ReportDialog.utils';

const SourceTable: FC<SourceTableProps> = ({ rows }) => (
  <Table size="small" data-testid="daily-nav-report-payload" sx={{ borderCollapse: 'separate' }}>
    <TableHead>
      <TableRow>
        <TableCell sx={headerCellSx}>Fund</TableCell>
        <TableCell sx={headerCellSx}>Security Identifier</TableCell>
        <TableCell sx={headerCellSx}>Currency</TableCell>
        <TableCell sx={{ ...headerCellSx, textAlign: 'right' }}>Report Date Price</TableCell>
        <TableCell sx={headerCellSx}>Report Date</TableCell>
        <TableCell sx={headerCellSx}>Notes</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {rows.map((row, index) => (
        <TableRow
          key={`${row.company_id}-${row.fund_name}-${row.security_identifier}-${index}`}
          sx={{ bgcolor: index % 2 === 1 ? colors.zebra : 'common.white' }}>
          <TableCell sx={bodyCellSx}>{row.fund_name}</TableCell>
          <TableCell sx={bodyCellSx}>{row.security_identifier || '—'}</TableCell>
          <TableCell sx={bodyCellSx}>{row.currency || '—'}</TableCell>
          <TableCell sx={{ ...bodyCellSx, textAlign: 'right' }}>
            {formatPrice(row.valuation_price_per_share, row.currency)}
          </TableCell>
          <TableCell sx={bodyCellSx}>{formatDate(row.report_date)}</TableCell>
          <TableCell sx={{ ...bodyCellSx, whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {row.daily_nav_notes}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default SourceTable;
